import React, { Component } from 'react';
import StartSound from '../../asset/sound/start_sound.mp3';
import EndSound from '../../asset/sound/score_sound.mp3';
import {isMobile} from "../../asset/js/myFunctions";



const withRecognizer = () => (WrappedComponent) => {
    //
    // let currentIndex = 0;
    // let lastDebounceTranscript = "";

    return class extends Component {
        state = {
            // show: false,
            listening: false,
            text:null,
            recognizerReady:false,
            isRecognizeSuccess: false,
        };
        _isMounted = false;
        fakeRecognitionEndTimer = null;
        pendingResult = null; //onend에서 넘길 마지막 인식 결과

        safeSetState = (state, callback) => {
            if(this._isMounted) {
                this.setState(state, callback);
            }
        };

        clearFakeRecognitionEndTimer = () => {
            if(this.fakeRecognitionEndTimer !== null) {
                clearTimeout(this.fakeRecognitionEndTimer);
                this.fakeRecognitionEndTimer = null;
            }
        };

        fakeRecognitionEndLater = () => {
            this.clearFakeRecognitionEndTimer();
            this.fakeRecognitionEndTimer = setTimeout(() => {
                this.fakeRecognitionEndTimer = null;
                if(this._isMounted) {
                    this.fakeRecognitionEnd();
                }
            }, 1000);
        };

        initialize() {
            // alert("start recognition");
            const Recognition =
                window.SpeechRecognition || window.webkitSpeechRecognition;

            if (!Recognition) {
                alert(
                    '음성인식 기능을 사용할 수 없습니다. PC 또는 Android 기기에서 Chrome 브라우저를 이용해 주세요.'
                );
                return;
            }

            this.recognition = new Recognition();
            this.recognition.lang = 'en-US';
            this.recognition.continuous = false;
            this.recognition.interimResults = false;
            this.recognition.maxAlternatives = 1;

            this.recognition.onresult = event => {
                const text = event.results[0][0].transcript;
                // if(lastDebounceTranscript === text && currentIndex === this.props.wordInfo.num){
                //     return;
                // } else {
                //     lastDebounceTranscript = text;
                //     currentIndex = this.props.wordInfo.num;
                // }

                //Android·PC Chrome 모두 interimResults=false여도 말하는 도중 중간 결과를 여러 번 보낸다(2026-10 확인).
                //여기서 바로 처리하면 점수가 실시간으로 바뀌고 중간 결과마다 채점·한글 오류 처리가 반복되므로,
                //마지막 결과만 보관했다가 onend에서 한 번 처리한다.
                this.pendingResult = text;
                this.safeSetState({
                    text,
                    isRecognizeSuccess: true,
                });
            };

            // this.recognition.onspeechend = () => {
            //     //console.log('stopped');
            //
            //     this.setState({
            //         show: true,
            //     });
            // };

            this.recognition.onnomatch = event => {
                //console.log('no match');
                this.safeSetState({ text: null });
            };

            this.recognition.onstart = () => {
                //console.log('Recognizer start');
                if(!isMobile) {
                    let startAudio = new Audio(StartSound);
                    startAudio.play();
                }

                // let startAudio = new Audio(StartSound);
                // startAudio.play();

                this.pendingResult = null;
                this.safeSetState({
                    text:null,
                    listening: true,
                    recognizerReady:false,
                    isRecognizeSuccess: false,
                });
            };

            this.recognition.onend = () => {
                //console.log('Recognizer end');
                if(!isMobile){
                    let endSound = new Audio(EndSound);
                    endSound.play();
                }

                // if(this.props.audioPause() !== null){ //쉐도잉 할때, 녹음 종료되면 음원도 같이 종료됨.
                //     this.props.audioPause();
                // }

                if(this.pendingResult !== null) {
                    const text = this.pendingResult;
                    this.pendingResult = null;
                    console.log('transcript', text);

                    if(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(text)) { //어떤 이유로 음성인식을 한글로 받아옴.
                       // this.props.handleError(text, this.props.wordInfo.num);
                        if(this.props.handleError){
                            //영어(en-US)로 요청해도 한국어처럼 발음하면 인식 서버가 한글로 받아쓴다(2026-10 PC Chrome·구글 데모에서 확인).
                            this.props.handleError([
                                "한국어 발음으로 인식되었습니다.",
                                <br />,
                                "원어민 발음을 다시 듣고, 영어 발음으로 또박또박 말해 보세요."
                            ]);
                        }
                    } else {
                        this.props.setResult(text, this.props.wordInfo.num);
                    }
                }

                if(this.state.text === null && this.state.isRecognizeSuccess === false && this.props.handleError){
                    this.props.handleError(["죄송합니다. 알아 듣지 못했습니다.", <br />, "다시 한번 ",<strong>테스트</strong>,"하세요.", <br />,"가급적 조용한 환경에서 수업해 주세요."]);
                }

                //reset
                this.safeSetState({
                    listening: false,
                    text:null,
                    recognizerReady:true,
                    isRecognizeSuccess: false,
                })



                //this.endRecognition();


            };

            this.recognition.onerror = event => {
                console.log('error', event);
                this.pendingResult = null; //오류로 끝난 시도는 채점하지 않는다
                //alert("error occured!");
                if(this.props.handleError){
                    //this.props.handleError("ERROR:"+event.toString());
                    this.props.handleError(["음성이 입력되지 않았습니다. ", "마이크를 확인하시고 더 크게 말해주세요.",<br />,"문제가 계속된다면 ",
                        <strong>원격 지원</strong>,"을 받아주세요."]);
                }
                this.safeSetState({
                    // show: true,
                    listening: false,
                    text: event.error,
                    isRecognizeSuccess: false,
                });
            };
        }

        componentDidMount(){
            this._isMounted = true;
            this.initialize(); //Initialize
            if(this.state.recognizerReady === false){
                //console.log("recognizer is ready");
                this.safeSetState({
                    recognizerReady:true
                })
            }
        }

        componentWillUnmount() {
            this._isMounted = false;
            this.clearFakeRecognitionEndTimer();

            if(this.recognition) {
                this.recognition.onresult = null;
                this.recognition.onnomatch = null;
                this.recognition.onstart = null;
                this.recognition.onend = null;
                this.recognition.onerror = null;

                try {
                    this.recognition.stop();
                } catch (e) {
                    // recognition may already be stopped in some browsers.
                }
            }
        }

        startRecognition(){
            if(this.state.listening === true){
                //console.log("already listening");
                return;
            }
            //this.recognition.stop();
            try {
                this.recognition.start();
            } catch (e) {
                //listening은 onstart에서야 true가 되므로, start() 직후 다시 불리면 InvalidStateError가 난다.
                //이미 시작된 상태라 무시해도 되고, getDerivedStateFromProps에서 던지면 화면 전체가 멈추므로 여기서 막는다.
                console.log('recognition start skipped:', e && e.name);
            }
            //console.log("start recognition");
        }

        endRecognition(){
            this.recognition.stop();
        }
        //
        // handleClose(){
        //
        //     this.setState({
        //         show:false,
        //     })
        // }

        fakeRecognitionStart(){
            let startAudio = new Audio(StartSound);
            startAudio.play();

            //console.log("페이크 시작");
            this.safeSetState({
                text:null,
                listening: true,
                recognizerReady:false,
                isRecognizeSuccess: false,
            });
        }

        fakeRecognitionEnd(){
            let endSound = new Audio(EndSound);
            endSound.play();
            //console.log("페이크 끝.");
            this.props.setResult("iOSResult", this.props.wordInfo.num);
            this.safeSetState({
                text:null,
                isRecognizeSuccess: true,
                listening: false,
                recognizerReady:true,
            });
        }

        render(){
            return (
                <WrappedComponent {...this.props}
                                  recognizerReady={this.state.recognizerReady}
                                  text={this.state.text}
                                  listening={this.state.listening}
                                  startRecognition={this.startRecognition.bind(this)}
                                  endRecognition={this.endRecognition.bind(this)}
                                  fakeRecognitionStart={this.fakeRecognitionStart.bind(this)}
                                  fakeRecognitionEnd={this.fakeRecognitionEnd.bind(this)}
                                  fakeRecognitionEndLater={this.fakeRecognitionEndLater.bind(this)}
                                  // handleClose={this.handleClose.bind(this)}
                />
            );
        }
    }

};

export default withRecognizer;
